"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Analytics_1 = __importDefault(require("../Analytics"));
var TrackerUtil = /** @class */ (function () {
    function TrackerUtil() {
    }
    TrackerUtil.getInstance = function (options, instances, createInstance, isPlatformInstalled) {
        options = options;
        // Determine key for storing/retrieving instance
        var instanceKey = options.trackerName;
        if (instanceKey === undefined || instanceKey === null
            || instanceKey.length === 0) {
            instanceKey = TrackerUtil.defaultInstanceKey;
        }
        // Check for existing instance
        if (instances === undefined) {
            instances = new Map();
        }
        else {
            var instance = instances.get(instanceKey);
            if (instance !== undefined) { // Map.get() returns `undefined` if not set
                return instance;
            }
        }
        // Create instance and store
        if (isPlatformInstalled === undefined) {
            isPlatformInstalled = function () {
                // For most platforms we just check to see if the global platform object exists.
                // But some platforms (e.g. LinkedIn) do not have an official object which we can expect to be loaded at this point.
                return window[options.globalKeyForPlatform] !== undefined && window[options.globalKeyForPlatform] !== null;
            };
        }
        if (isPlatformInstalled()) {
            var instance = createInstance(options);
            instances.set(instanceKey, instance);
            return instance;
        }
        return null;
    };
    TrackerUtil.pagePathCleanup = function (pagePath) {
        if (pagePath.length === 0) {
            pagePath = "/";
        }
        else if (pagePath.substring(0, 1) !== "/") {
            pagePath = "/" + pagePath;
        }
        return pagePath;
    };
    TrackerUtil.eventActionToString = function (action) {
        return this.eventActionOrLabelToString(action);
    };
    TrackerUtil.eventLabelToString = function (label) {
        return this.eventActionOrLabelToString(label);
    };
    TrackerUtil.eventActionOrLabelToString = function (value) {
        if (value === undefined || value === null) {
            return;
        }
        if (Array.isArray(value)) {
            return value.join(Analytics_1.default.valueDelimiter) || Analytics_1.default.emptyValue;
        }
        return (typeof value !== "string") ? value.toString() : value;
    };
    TrackerUtil.isBasicPageviewTracker = function (tracker) {
        return typeof tracker.trackPageview === "function";
    };
    TrackerUtil.isBasicEventTracker = function (tracker) {
        return typeof tracker.trackEvent === "function";
    };
    TrackerUtil.defaultInstanceKey = "__default";
    return TrackerUtil;
}());
exports.default = TrackerUtil;
